<template>
  <b-nav
      id="nav"
      class="d-flex align-items-center rounded-1 gmb-observatory-entity-selector"
      pills
  >
    <b-nav-item-dropdown
        class="flex-grow-1"
        menu-class="mt-3 border p-0 rounded-1 gmb-observatory-entity-selector__bar"
        no-caret
        toggle-class="d-flex p-2 rounded-1 align-items-center gmb-observatory-entity-selector__bar-item"
    >
      <template #button-content>
        <GmbObsboxItem
            class="flex-grow-1 w-0"
            :client="activatedEntity.client"
            is-for-display
            :item-id="activatedEntity.identifier.toString()"
            :organization="activatedEntity.organization"
            :project="activatedEntity.project"
        />
        <FdText fa>
          <i class="mr-2 fas fa-caret-down"/>
        </FdText>
      </template>

      <div
          class="d-flex p-1 flex-column gmb-observatory-entity-selector__obsbox"
          :style="{'height': selectorHeight +'px'}"
      >
        <GmbRadioButtonGroup
            :activatedValue="activatedEntity.identifier.toString()"
            @activated-value-changed="
            (newActivatedEntitySlug) =>
              $emit('activated-entity-changed', newActivatedEntitySlug)
          "
        >
          <GmbObsbox :entities="entities"/>
        </GmbRadioButtonGroup>
      </div>
    </b-nav-item-dropdown>
  </b-nav>
</template>

<script>
import FdText from "@/flexdesign/Text";

import GmbObsbox from "@/widgets/Obsbox";
import GmbObsboxItem from "@/widgets/ObsboxItem";
import GmbRadioButtonGroup from "@/widgets/RadioButtonGroup";

export default {
  name: "GmbObservatoryEntitySelector",

  components: {
    FdText,
    GmbObsbox,
    GmbObsboxItem,
    GmbRadioButtonGroup,
  },

  props: {
    entities: Array,
    activatedEntity: Object,
  },

  data() {
    return {};
  },

  computed: {
    selectorHeight() {
      // BEWARE, better be too high than make the scrollbar appear too early!
      return 32 + 38 * this.entities.length;
    }
  },

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {},
};
</script>

<style lang="scss">
@import "@/sass/settings/colors";
@import "@/sass/settings/dimensions";
@import "@/sass/bootstrap-overloads/colors";
@import "@/../node_modules/bootstrap/scss/functions";
@import "@/../node_modules/bootstrap/scss/variables";

/* =========================================================================
 * OBSERVATORY ENTITY SELECTOR
 * ========================================================================= */

.gmb-observatory-entity-selector {
  width: $gmb-block-dropdown-width;
  background-color: rgba($gmb-color-white, 0.1);

  &:hover {
    background-color: rgba($gmb-color-white, 0.15);
  }

  &__bar {
    margin-left: calc(-1 * #{$border-width});
    background-color: rgba($gmb-color-theme-1, 0.95) !important;
    color: $gmb-color-white !important;

    &-item {
      background-color: unset !important;
      color: $gmb-color-white;

      &:hover {
        color: $gmb-color-white !important;
      }
    }
  }

  &__obsbox {
    width: $gmb-block-dropdown-width;
    max-height: $gmb-block-dropdown-height-max;
  }
}
</style>
